// generate MLA standard citation format

function getMLAEdition(tags) {
    return Object.prototype.hasOwnProperty.call(tags, 'edition') ? `(${tags.edition.join(', ')})` : '';
}
function getMLAAuthors(tags) {
    if (!Object.prototype.hasOwnProperty.call(tags, 'author')) {
        return '';
    }
    const authors = [];
    $.each(tags.author, (index, value) => {
        value = mlaFormatName(value);
        authors.push(value);
    });
    return authors.join(', ');
}
function _getMLACountry(tags) {
    return Object.prototype.hasOwnProperty.call(tags, 'country') ? `${tags.country.join(', ')}: ` : '';
}
function getMLAPublisher(tags) {
    return Object.prototype.hasOwnProperty.call(tags, 'publisher') ? tags.publisher.join(', ') : '';
}
function getMLAPublicationDate(issue) {
    return Object.prototype.hasOwnProperty.call(issue, 'publication_date') ? `${issue.publication_date}` : '';
}
function getMLATitle(issue, title) {
    return Object.prototype.hasOwnProperty.call(issue, 'title') && issue.title.length ? issue.title : title;
}
function getMLAIssueUrl(issue, currentLocation, isEpub = false, _localizations) {
    const location = isEpub ? btoa(JSON.stringify(currentLocation)) : currentLocation;
    return Object.prototype.hasOwnProperty.call(issue, 'issue_url') > 0
        ? `${issue.issue_url}?location=${location}`
        : '';
}
function mlaFormatName(name) {
    return name.replace(/^(.+?) ([^\s,]+)(,? (?:[JS]r\.?|III?|IV))?$/i, '$2, $1$3');
}

function formatValue(string, punctuation = null) {
    punctuation = punctuation ? punctuation : '.';
    const trimmedString = string.trim();
    if (!trimmedString) {
        return '';
    }
    return trimmedString.endsWith(punctuation) ? `${trimmedString} ` : `${trimmedString}${punctuation} `;
}

const MLACitation = (text, issue, currentLocation, issueTitle, isEpub, localizations) => {
    const author = getMLAAuthors(issue.tags);
    const date = getMLAPublicationDate(issue);
    const title = getMLATitle(issue, issueTitle);
    const _edition = getMLAEdition(issue.tags);
    const publisher = getMLAPublisher(issue.tags);
    const url = getMLAIssueUrl(issue, currentLocation, isEpub, localizations);
    const websiteName = localizations.citation.messages.websiteName;

    const citation = `${formatValue(author)}${formatValue(title)}${formatValue(publisher, ',')}${formatValue(date)}${formatValue(
        websiteName,
        ','
    )}${url}`;

    if (text && text.trim()) {
        return `"${text}"

${citation}`;
    }

    return citation;
};

export default MLACitation;
